import { NavLink, Outlet } from "react-router";
import { SiteHeader } from "@/components/navigation/site-header";
import { SkipLink } from "@/components/accessibility/skip-link";
import { useLocale } from "@/features/localisation/locale-context";

export function RootLayout() {
  const { t } = useLocale();
  return (
    <>
      <SkipLink />
      <SiteHeader />
      <Outlet />
      <footer className="border-border bg-surface mt-16 border-t">
        <div className="text-small text-text-muted mx-auto max-w-7xl px-6 py-8">
          {t("footer.tagline")}
        </div>
      </footer>
    </>
  );
}
export function WorkspaceLayout({ label }: { label: string }) {
  const { t } = useLocale();
  const links: Array<readonly [string, string]> =
    label === "Teacher"
      ? [
          ["/teacher/sessions", t("workspace.sessions")],
          ["/teacher/classes", t("workspace.classes")],
        ]
      : label === "Researcher"
        ? [["/researcher/studies", t("workspace.studies")]]
        : label === "Platform"
          ? [
              ["/platform/dashboard", t("workspace.dashboard")],
              ["/platform/organisations", t("workspace.organisations")],
              ["/platform/users", t("workspace.users")],
              ["/platform/audit", t("workspace.audit")],
            ]
          : [["/admin/organisations", t("workspace.organisations")]];
  const workspaceLabel =
    label === "Teacher"
      ? t("workspace.teacher")
      : label === "Researcher"
        ? t("workspace.researcher")
        : label === "Platform"
          ? t("workspace.platform")
          : t("workspace.admin");
  return (
    <div className="mx-auto grid max-w-7xl gap-6 px-4 py-8 lg:grid-cols-[14rem_1fr] lg:px-6">
      <aside aria-label={workspaceLabel} className="rounded-card bg-primary p-5 text-white">
        <p className="font-bold">{workspaceLabel}</p>
        <nav className="mt-5 grid gap-2" aria-label={workspaceLabel}>
          {links.map(([to, text]) => (
            <NavLink
              className="rounded-control px-3 py-2 text-sm font-semibold text-white hover:bg-white/10"
              key={to}
              to={to}
            >
              {text}
            </NavLink>
          ))}
        </nav>
      </aside>
      <main id="main-content" className="min-w-0">
        <Outlet />
      </main>
    </div>
  );
}
export function PlayLayout() {
  const { t } = useLocale();
  return (
    <main id="main-content" className="mx-auto min-h-[70vh] max-w-6xl px-4 py-8">
      <p className="text-participation mb-4 text-sm font-semibold">{t("student.activity")}</p>
      <Outlet />
    </main>
  );
}
